/* eslint-disable no-case-declarations */
import {
  validateEst,
  validateInvNumber,
  validateItemPrice,
  validateLot,
  validateLotTitle,
  validateLotDescription,
  validateReserve,
  validateShippingField,
  validateStartingBid,
  validateRealizedPrice
} from './EditLotValidation';

const validateLotForm = (
  deletedLots,
  fieldName,
  invNumberArray,
  lotData,
  lotNumberArray,
  type,
  validation,
  isGoldPlatinum,
) => {
  switch (fieldName) {
    // These two need to be tested together
    case 'lotNumber':
    case 'lotExt':
      const { lotNumber, lotExt } = validateLot(
        deletedLots,
        lotData.lotNumber,
        lotData.lotExt,
        lotNumberArray,
        lotData.invNumber,
        isGoldPlatinum,
        type.toLowerCase() === 'bin' ? 'bin' : null,
      );
      validation.lotNumber = lotNumber;
      validation.lotExt = lotExt;
      break;
    case 'lotTitle':
      validation.lotTitle = validateLotTitle(lotData.lotTitle);
      break;
    case 'lotDescription':
      validation.lotDescription = validateLotDescription(lotData.lotDescription);
      break;
    case 'shipWidth':
      validation.shipWidth = validateShippingField('Shipping Width', lotData.shipWidth);
      break;
    case 'shipHeight':
      validation.shipHeight = validateShippingField('Shipping Height', lotData.shipHeight);
      break;
    case 'shipLength':
      validation.shipLength = validateShippingField('Shipping Length', lotData.shipLength);
      break;
    case 'shipWeight':
      validation.shipWeight = validateShippingField('Total Weight', lotData.shipWeight);
      break;
    case 'shipping':
      validation.shipping = validateShippingField('Shipping (Domestic)', lotData.shipping);
      break;
    case 'shippingIntl':
      validation.shippingIntl = validateShippingField('Shipping (International)', lotData.shippingIntl);
      break;
    // These two need to be tested together
    case 'loEst':
    case 'hiEst':
      const { loEst, hiEst } = validateEst(lotData.loEst, lotData.hiEst);
      validation.loEst = loEst;
      validation.hiEst = hiEst;
      break;
    case 'itemPrice':
      validation.itemPrice = validateItemPrice(lotData.itemPrice);
      break;
    case 'realizedPrice':
      validation.realizedPrice = validateRealizedPrice(lotData.realizedPrice);
      break;
    case 'startingBid':
      validation.startingBid = validateStartingBid(lotData.startingBid);
      break;
    case 'invNumber':
      validation.invNumber = validateInvNumber(lotData.invNumber, invNumberArray, lotData.lotNumber, isGoldPlatinum);
      break;
    case 'reserve':
      validation.reserve = validateReserve(lotData.reserve);
      break;
    default:
      return validation;
  }
  return validation;
};

export default validateLotForm;
